// extracted by mini-css-extract-plugin
module.exports = {"expandIcon":"style_expandIcon__28tu9"};